import _ from "lodash";
import VueApollo from "vue-apollo";
import ApolloClient from "apollo-boost";

let $localStorage = {
  _getFromStorage: function() {
    let tmp = localStorage.getItem("whitebox");
    try {
      tmp = JSON.parse(tmp);
      if (typeof tmp !== "object" || tmp == null) {
        tmp = {};
      }
    } catch ($e) {
      tmp = {};
    }
    return tmp;
  },
  set: function(path, value) {
    let tmp = this._getFromStorage();
    _.set(tmp, path, value);
    localStorage.setItem("whitebox", JSON.stringify(tmp));
  },
  get: function(path) {
    return _.get(this._getFromStorage(), path, null);
  },
  unset: function(path) {
    let tmp = this._getFromStorage();
    _.unset(tmp, path);
    localStorage.setItem("whitebox", JSON.stringify(tmp));
  }
};

export { $localStorage };

export default {
  name: "features",
  install(Vue, options) {
    options.store.commit("setI18N", options.i18n);

    Object.defineProperty(Vue.prototype, "$api_loading", {
      get: () => options.store.getters["app/loading"]
    });

    Vue.prototype.$_ = _;

    Vue.prototype.$log =
      localStorage.getItem("whitebox_spa_mode") !== "debug"
        ? () => {}
        : console.log;

    Vue.prototype.$localStorage = $localStorage;

    Vue.prototype.$api = {
      client: new VueApollo({
        defaultClient: new ApolloClient({
          uri:
            process.env.VUE_APP_API_URL.replace(/\/*$/, "/") +
            process.env.VUE_APP_API_PATH.replace(/^\/+/, "").replace(
              /\/+$/,
              ""
            ),
          request: operation => {
            operation.setContext({
              headers: {
                authorization: options.store.getters["user/getBearer"]
              }
            });
          }
        })
      }),
      _catchHandler: () => {},
      set catchHandler(callback) {
        this._catchHandler = callback;
      },
      _dispatchAfterResponse(res, skip_dispatcher = false) {
        Vue.prototype.$log(res.data);
        if (!skip_dispatcher) {
          let data = res.data;
          Object.keys(data).forEach(k => {
            if (typeof options.store._actions[`${k}/${k}`] !== "undefined") {
              options.store.dispatch(`${k}/${k}`, data[k]);
            }
          });
        }
        options.store.commit("app/decrement");
        return res;
      },
      mutate(v, skip_dispatcher = false) {
        options.store.commit("app/increment");
        return this.client.defaultClient.resetStore().then(() => {
          return this.client.defaultClient
            .mutate(v)
            .then(res => {
              Vue.prototype.$log("features.mutate:then :: res", res);
              return this._dispatchAfterResponse(res, skip_dispatcher);
            })
            .catch(res => {
              options.store.commit("app/decrement");
              Vue.prototype.$log("features.mutate:catch :: res", res);
              this._catchHandler(res);
              return Promise.reject(res);
            });
        });
      },
      query(v, skip_dispatcher = false) {
        options.store.commit("app/increment");
        return this.client.defaultClient.resetStore().then(() => {
          return this.client.defaultClient
            .query(v)
            .then(res => {
              Vue.prototype.$log("features.query :: res", res);
              return this._dispatchAfterResponse(res, skip_dispatcher);
            })
            .catch(res => {
              options.store.commit("app/decrement");
              this._catchHandler(res);
              return Promise.reject(res);
            });
        });
      }
    };

    options.store.commit("setAPI", Vue.prototype.$api);
  }
};
